// src/components/TaskForm.jsx
import React, { useState } from "react";
import PropTypes from "prop-types";

const TaskForm = ({ onSubmit, placeholder = "Enter task", buttonText = "Add Task", isEditing, onCancel }) => {
  const [task, setTask] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (task.trim()) {
      onSubmit(task.trim());
      setTask("");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="task-form">
      <div className="task-label">
        <input
          type="text"
          value={task}
          onChange={(e) => setTask(e.target.value)}
          placeholder={placeholder}
          className="task-input"
        />
      </div>
      <div className="button-group">
        <button type="submit" className="btn btn-save">
          {buttonText}
        </button>
        {isEditing && (
          <button type="button" className="btn btn-cancel" onClick={onCancel}>
            Cancel
          </button>
        )}
      </div>
    </form>
  );
};

TaskForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  buttonText: PropTypes.string,
  isEditing: PropTypes.bool,
  onCancel: PropTypes.func,
};

export default TaskForm;
